<template>
  <div class="row">
    <div class="top-bar at-top-bar container-fluid" v-bind:class="{'top-bar-120': !$store.state.mobile}">
      <div><p>Attendance Tracking ({{ totalCount }} items)</p></div>
      <burger/>
      <div class="ml-auto right-aligned-filters" v-show="!$store.state.mobile">
        <div class="row attendance-filters at-filters">
          <div class="top-bar-filter at-filter-user" style="border-left: 0;">
            <user-search-filter :initial="filters.user_id" @chosen="setFilter('user_id', $event.id)"/>
          </div>
          <div class="top-bar-filter top-bar-filter-second at-second-filter">
            <p class="label">Filter:</p>
            <location-filter :location="filters.location_id" @location="setFilter('location_id', $event)" id="location-filter"/>
          </div>
          <div class="top-bar-filter top-bar-filter-calendar">
            <date-range-filter :start="date_start" :end="date_end" @selectDay="updateDateFilter($event)"/>
          </div>
          <div class="top-bar-filter top-bar-filter-time at-time-filter">
            <time-filter @selectTime="setTime($event)"/>
          </div>
        </div>
      </div>
    </div>

    <div class="container-main">
      <div class="container-fluid right-container attendance-container" id="items-container">
        <div class="container-fluid mb-filters" v-bind:class="{'height-7': !showFiltersMobile}">
          <div class="sliding-filters" v-show="showFiltersMobile">
            <div class="mb-filter">
              <user-search-filter @chosen="setFilter('user_id', $event.id)"/>
            </div>
            <div class="row mb-filter-room">
              <location-filter :location="filters.location_id" @location="setFilter('location_id', $event)" />
            </div>
            <div class="row mb-filter-date">
              <date-range-filter :start="date_start" :end="date_end" @selectDay="updateDateFilter($event)"/>
            </div>
            <div class="row mb-filter-time">
              <time-filter @selectTime="setTime($event)"/>
            </div>
          </div>
          <div class="row filter-btn" @click="toggleFiltersMobile">
            <i class="fa fa-chevron-circle-up ml-auto" v-if="showFiltersMobile"></i>
            <i class="fa fa-chevron-circle-down ml-auto" v-else></i>
          </div>
        </div>
        <v-infinite-scroll :loading="$store.state.loading" @bottom="loadMore" :offset='20'
        style="max-height: 90vh; overflow-y: scroll;" :class="{ 'small-items-table': showFiltersMobile, 'height-93': !showFiltersMobile}">
          <table class="table items-table">
            <tbody>
              <tr class="item" v-for="(item, key) in items" :key="key"
                v-if="item.location.is_classroom == 1" @click="redirect(item.user.id)">
                <td class="avatar">
                  <div class="cam-label">
                    <p>{{ item.location.name }}</p>
                  </div>
                  <user-photo :user="item.user" cssClass="identified-border"/>
                </td>
                <td class="col-name">
                  <p>Name</p>
                  <p>{{ item.user.first_name }} {{ item.user.last_name }}</p>
                </td>
                <td class="col-time col-time-first">
                  <p>Room</p>
                  <p>{{ item.location.name }}</p>
                </td>
                <td class="col-time col-time-second">
                  <p>First seen</p>
                  <p>{{ moment(item.first_seen).format('MMMM DD / h:mm a') }}</p>
                </td>
                <td class="col-time col-time-third">
                  <p>Last seen</p>
                  <p>{{ item.last_seen ? moment(item.last_seen).format('MMMM DD / h:mm a') : '' }}</p>
                </td>
                <td class="col-donut">
                  <div class="progress-pie"  :data-value="item.percent" ></div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-infinite-scroll>
      </div>
    </div>
  </div>
</template>

<script>
  import IdentifyModal from '@/components/IdentifyModal';
  import UserSearchFilter from '@/components/filters/UserSearch';
  import LocationFilter from '@/components/filters/Location';
  import DateRangeFilter from '@/components/filters/DateRange';
  import TimeFilter from '@/components/filters/Time';
  import UserPhoto from '@/components/users/Photo';
  import Burger from '@/components/Burger';

  export default {
    name: 'AttendanceTracking',
    components: {
      IdentifyModal,
      UserSearchFilter,
      LocationFilter,
      DateRangeFilter,
      TimeFilter,
      UserPhoto,
      Burger
    },
    data() {
      return {
        load: true,
        date_start: new Date(),
        date_end: new Date(),
        items: [],
        totalCount: 0,
        showFiltersMobile: true,
        showSideBarMobile: false,
        filters: {
          'user_id': null,
          'location_id': null,
          'date_start': this.moment().format('YYYY-MM-DD'),
          'date_end': this.moment().format('YYYY-MM-DD'),
          'start': 0,
          'limit': 20,
          'time_start': { HH: '', mm: '' },
          'time_end': { HH: '', mm: '' },
        },
      };
    },

    mounted() {
      if (this.$router.currentRoute.query.user_id) {
        this.filters.user_id = this.$router.currentRoute.query.user_id;
      }

      this.getItems();
    },
    methods: {
      getItems() {
        this.load = true;
        this.resetPagination();

        this.axios.get(`/attendance?${this.getFilters()}`)
          .then(response => {
            if (!response.data.results.length) {
              this.load = false;
            }

            this.items = response.data.results;
            this.totalCount = response.data.total_count || 0;
          });
      },
      loadMore() {
        if (!this.load) {
          return;
        }

        this.filters.start += (!this.filters.start ? 20 : 10);
        this.filters.limit = 10;

        this.axios.get(`/attendance?${this.getFilters()}`)
          .then(response => {
            if (!response.data.results.length) {
              this.load = false;
            }

            for (let i in response.data.results) {
              this.items.push(response.data.results[i]);
            }
            // Update total count if provided
            if (response.data.total_count !== undefined) {
              this.totalCount = response.data.total_count;
            }
          });
      },
      updateDateFilter(dates) {
        this.filters.date_start = this.moment(dates.start).format('YYYY-MM-DD');
        this.filters.date_end = this.moment(dates.end).format('YYYY-MM-DD');
        this.getItems();
      },
      getFilters() {
        let data = window._.omit(this.filters, ['time_start', 'time_end', 'date_start', 'date_end']), filters = [];

        window._.forIn(data, function (value, index) {
          if (value != null) {
            filters.push(`${index}=${value}`);
          }
        });

        filters.push(`date_start=${this.filters.date_start}`);
        filters.push(`date_end=${this.filters.date_end}`);

        filters.push(`time_start=${this.getTime(this.filters.time_start)}`);
        filters.push(`time_end=${this.getTime(this.filters.time_end, '23:59:59')}`);

        return filters.join('&');
      },
      redirect(id) {
        let data = window._.omit(this.filters, ['user_id', 'limit', 'start']), filters = [];

        window._.forIn(data, function (value, index) {
          if (index == 'time_start' || index == 'time_end') {
            if (value.HH) {
              filters.push(`${index}=${value.HH}:${value.mm}`);
            }
          } else if (value) {
            filters.push(`${index}=${value}`);
          }
        });

        this.$router.push(`/events?user_id=${id}&${filters.join('&')}`);
      },
      toggleFiltersMobile() {
        this.showFiltersMobile = !this.showFiltersMobile;
      }
    },
  };


</script>

<style scoped>
  .top-bar-filter-calendar {
    width: 285px !important;
  }
</style>
